// extracted by mini-css-extract-plugin
export default {"container":"Faq-module__container__y6xsc","accordion":"Faq-module__accordion__Vd2Ct"};